









































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import BaseServiceMixin from "../mixins/base.service.mixin";
import XeroService from "../services/xero.service";
import { XeroContactModel } from "@/models/XeroContactModel";
import { PhoneType, AddressType, CurrencyCode } from "../common/enum";
import CountryCodes from "@/common/CountryCodes.json";
import { XeroPhoneModel } from "../models/XeroPhoneModel";
import { XeroAddressModel } from "../models/XeroAddressModel";

@Component({
  components: {
    ValidationObserver,
  },
})
export default class XeroIntegration extends Mixins(BaseServiceMixin) {
  private xeroService!: XeroService;
  private xeroContact: XeroContactModel = new XeroContactModel();
  private phoneType = PhoneType;
  private addressType = AddressType;
  private currencyCode = CurrencyCode;
  private loading = false;
  private countryCodes = CountryCodes;
  private isVAT = false;

  private get isEdit(): boolean {
    return this.xeroContact.contactID && this.xeroContact.contactID !== "" ? true : false;
  }

  public created() {
    this.xeroService = new XeroService(this.axiosInstance);
  }

  private async mounted() {
    await this.getContact();
  }

  @Watch("isVAT")
  private onVATChange() {
    if (!this.isVAT) {
      this.xeroContact.taxNumber = "";
    }
  }

  private async getContact() {
    this.loading = true;
    try {
      const xeroContact = await this.xeroService.getXeroContact();
      if (xeroContact.phones && xeroContact.phones.length > 1) {
        const defaultPhone = xeroContact.phones.find((phone: XeroPhoneModel) => phone.phoneType === PhoneType.DEFAULT);
        if (defaultPhone) {
          xeroContact.phones = [defaultPhone];
        } else {
          xeroContact.phones = [xeroContact.phones[0]];
        }
      }
      if (xeroContact.addresses && xeroContact.addresses.length > 1) {
        const defaultAddress = xeroContact.addresses.find(
          (address: XeroAddressModel) => address.addressType === AddressType.POBOX,
        );
        if (defaultAddress) {
          xeroContact.addresses = [defaultAddress];
        } else {
          xeroContact.addresses = [xeroContact.addresses[0]];
        }
      }

      if (xeroContact.taxNumber && xeroContact.taxNumber !== "") {
        this.isVAT = true;
      } else {
        this.isVAT = false;
      }
      this.xeroContact = xeroContact;
    } catch (error) {
      //Handle Error
    } finally {
      this.loading = false;
    }
  }

  private async saveXeroContact() {
    this.loading = true;
    try {
      await this.xeroService.upsertXeroContact(this.xeroContact);
      await this.getContact();
      if (!this.vuexStore.user?.isXeroLinked) {
        this.vuexStore.setUser({ ...this.vuexStore.user!, isXeroLinked: true });
      }
    } catch (error) {
      //Handle Error
    } finally {
      this.loading = false;
    }
  }
}
